import { v4 as uuid } from 'uuid';

export default [
  {
    id: uuid(),
    workdescription: 'Work Description #1',
    startedAt: 1555016400000,
    workhour: '304-428-3097',
    address: {
      country: 'USA',
      state: 'West Virginia',
      city: 'Parkersburg',
      street: '2849 Fulton Street'
    },
    isPlanned: false,
    actualCompletionDate: null
  },
  {
    id: uuid(),
    workdescription: 'Work Description #2',
    startedAt: 1555016400000,
    workhour: '304-428-3097',
    address: {
      country: 'USA',
      state: 'West Virginia',
      city: 'Parkersburg',
      street: '2849 Fulton Street'
    },
    isPlanned: false,
    actualCompletionDate: null
  },
  {
    id: uuid(),
    workdescription: 'Work Description #3',
    startedAt: 1555016400000,
    workhour: '304-428-3097',
    address: {
      country: 'USA',
      state: 'West Virginia',
      city: 'Parkersburg',
      street: '2849 Fulton Street'
    },
    isPlanned: true,
    actualCompletionDate: null
  },
  {
    id: uuid(),
    workdescription: 'Work Description #4',
    startedAt: 1555016400000,
    workhour: '304-428-3097',
    address: {
      country: 'USA',
      state: 'West Virginia',
      city: 'Parkersburg',
      street: '2849 Fulton Street'
    },
    isPlanned: true,
    actualCompletionDate: null
  },  
  {
    id: uuid(),
    workdescription: 'Work Description #5',
    startedAt: 1555016400000,
    workhour: '304-428-3097',
    address: {
      country: 'USA',
      state: 'West Virginia',
      city: 'Parkersburg',
      street: '2849 Fulton Street'
    },
    isPlanned: true,
    actualCompletionDate: 1555016400000
  },
  {
    id: uuid(),
    workdescription: 'Work Description #6',
    startedAt: 1555016400000,
    workhour: '304-428-3097',
    address: {
      country: 'USA',
      state: 'West Virginia',
      city: 'Parkersburg',
      street: '2849 Fulton Street'
    },
    isPlanned: true,
    actualCompletionDate: 1555016400000
  }, 
];
